export default class FiltroModelliEventData{

    SitoIntervento;
    StatoIntervento;
    DataIntervento;

    constructor(sitoIntervento, statoIntervento, dataIntervento){
        this.SitoIntervento = sitoIntervento;
        this.StatoIntervento = statoIntervento;
        this.DataIntervento = dataIntervento;
    }
}